/* KvD: "Weiterlesen" fuer die Produktbeschreibung (nur mobil sichtbar, Desktop zeigt alles) */
(function () {
  function init() {
    document.querySelectorAll('.kvd-pdp-desc-slot--mobile [data-kvd-desc]:not([data-kvd-init])').forEach(function (desc) {
      desc.setAttribute('data-kvd-init', '');
      var body = desc.querySelector('.kvd-pdp-desc__body');
      var btn = desc.querySelector('.kvd-pdp-desc__toggle');
      if (!body || !btn) return;
      desc.classList.add('is-collapsible');
      // Nur einklappen, wenn der Text deutlich laenger als die Vorschau ist
      if (body.scrollHeight <= body.clientHeight + 40) {
        desc.classList.remove('is-collapsible');
        return;
      }
      btn.hidden = false;
      btn.addEventListener('click', function () {
        var open = desc.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (!open) desc.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
